import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import AppRoutes from "./AppRoutes";
import {
    BrowserRouter,
} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {deepOrange500} from 'material-ui/styles/colors';
// import injectTapEventPlugin from 'react-tap-event-plugin';
// injectTapEventPlugin();
const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});
ReactDOM.render(<BrowserRouter>
    <MuiThemeProvider muiTheme={muiTheme}>
        {AppRoutes}
    </MuiThemeProvider>
</BrowserRouter>, document.getElementById('root'));
registerServiceWorker();
